'use client'

import Script from 'next/script'

export function TidioChat() {
  return (
    <Script
      defer
      strategy="afterInteractive"
      src="//code.tidio.co/urmdlxyitw9op44mcjtgtiiqtxi977pa.js"
    />
  )
}
